module.exports = __webpack_public_path__ + "img/drop-down.a4da59a7.svg";